import styled from 'styled-components';

const base = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 1rem;
  background-color: ${(props) => props.theme.colors.background};
`;

const Frame = {
  Base: base,
};

export default Frame;
